/* Home page "Framed prints" band (theme template index, owner 2026-10-07).
 *
 * The framing landing page's 3D frame in miniature; frl-landing.css styles it.
 * 1. Swings in when the band scrolls into view, then sways and cycles black/white
 *    with the glossy sheen until the visitor touches it; every automatic switch also
 *    moves to the next sample photo (list: snippets/frl-hero-samples.liquid, same
 *    rotation as the landing hero). Animates for everyone
 *    (owner ruling, same as the landing page); ?motion=off switches it off.
 * 2. "Try it with your photo" previews the visitor's photo in the frame (an object
 *    URL; nothing is uploaded).
 * 3. "See it in every size" carries that photo and colour to the landing page through
 *    IndexedDB (db rpl-handoff, store items, key framing-try); frl-landing.js reads it
 *    once when the URL has tried=1. Without a photo it is a plain link.
 */
(function () {
  'use strict';
  var root = document.getElementById('frh');
  if (!root || root.getAttribute('data-frl-init')) return;
  root.setAttribute('data-frl-init', '1');

  var reduced = new URLSearchParams(location.search).get('motion') === 'off';
  if (!reduced) root.classList.add('frl-force-motion');
  var DB = 'rpl-handoff', STORE = 'items', KEY = 'framing-try';

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function track(name, extra) {
    try { window.dataLayer = window.dataLayer || []; var e = { event: name }; for (var k in extra) e[k] = extra[k]; window.dataLayer.push(e); } catch (err) {}
  }

  /* ---------------- colour ---------------- */
  var colour = root.getAttribute('data-colour') === 'white' ? 'white' : 'black';
  var autoTimer = null, interacted = false, visible = false, entered = false;
  function setColour(c, byUser) {
    var changed = c !== colour;
    colour = c;
    root.setAttribute('data-colour', c);
    $$('[data-frl-colour]').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-frl-colour') === c)); });
    $$('[data-frl-colour-label]').forEach(function (el) { el.textContent = c === 'white' ? 'White' : 'Black'; });
    if (byUser) userTouched();
    if (changed) kick();
  }
  function startAuto() {
    if (autoTimer || interacted) return;
    autoTimer = setInterval(function () {
      if (document.hidden || !visible) return;
      setColour(colour === 'black' ? 'white' : 'black', false);
      rotateHero();
    }, 3000);
    preloadHero(1);
  }
  function stopAuto() { if (autoTimer) clearInterval(autoTimer); autoTimer = null; }
  function userTouched() { interacted = true; stopAuto(); }
  $$('[data-frl-colour]').forEach(function (b) {
    b.addEventListener('click', function () { setColour(b.getAttribute('data-frl-colour'), true); });
  });

  /* ---------------- 3D frame: entrance on scroll, sway, sheen, drag ---------------- */
  var stage = $('.frl-3d');
  var angle = -14, kickAmp = 0, kickT0 = 0, raf = 0, drag = null, t0 = 0, sheenTimer = 0;
  function paint(deg) {
    angle = deg;
    root.style.setProperty('--frl-deg', deg.toFixed(2) + 'deg');
    root.style.setProperty('--frl-glare', Math.max(0, Math.min(100, 50 - (deg / 20) * 50)).toFixed(1) + '%');
  }
  function kick() {
    if (reduced) return;
    kickAmp = 16; kickT0 = performance.now();
    root.classList.remove('is-sheen'); void root.offsetWidth; root.classList.add('is-sheen');
    clearTimeout(sheenTimer);
    sheenTimer = setTimeout(function () { root.classList.remove('is-sheen'); }, 1350);
  }
  function tick(now) {
    if (!t0) t0 = now;
    if (!drag || !drag.active) {
      var idle = -14 * Math.cos(((now - t0) / 9000) * 2 * Math.PI) * 0.85;
      var k = kickAmp * Math.exp(-(now - kickT0) / 420) * Math.sin((now - kickT0) / 115);
      paint(angle + ((idle + k) - angle) * 0.12);
    }
    raf = requestAnimationFrame(tick);
  }
  function enter() {
    if (entered) return;
    entered = true;
    root.classList.remove('frh-pre');
    if (reduced) { paint(-12); root.classList.add('is-still'); return; }
    root.classList.add('is-entering');
    setTimeout(function () {
      root.classList.remove('is-entering');
      root.classList.add('is-live');
      if (visible && !raf) raf = requestAnimationFrame(tick);
    }, 1550);
    setTimeout(startAuto, 1900);
  }
  if (stage) {
    stage.addEventListener('pointerdown', function (e) { if (e.isPrimary) drag = { x: e.clientX, base: angle, active: false }; });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || !e.isPrimary) return;
      var dx = e.clientX - drag.x;
      if (!drag.active) {
        if (Math.abs(dx) < 6) return;
        drag.active = true; stage.classList.add('is-dragging'); userTouched();
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      paint(Math.max(-38, Math.min(38, drag.base + dx * 0.35)));
    });
    var release = function () { if (drag && drag.active) stage.classList.remove('is-dragging'); drag = null; };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if (window.IntersectionObserver) {
      // Hidden until it swings in, so it never pops from rest into the entrance.
      if (!reduced) root.classList.add('frh-pre');
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        visible = e.isIntersecting;
        if (visible && e.intersectionRatio >= 0.3) enter();
        if (reduced) return;
        if (visible && !raf && root.classList.contains('is-live')) raf = requestAnimationFrame(tick);
        if (!visible && raf) { cancelAnimationFrame(raf); raf = 0; }
      }, { threshold: [0, 0.3] }).observe(stage);
    } else {
      visible = true;
      enter();
    }
  }

  /* ---------------- photo rotation (same as the landing hero) ----------------
   * Each automatic switch crossfades the next sample in on top while the sheen passes.
   * Stops with the colour cycle and never replaces a visitor's own photo. */
  var heroSamples = [];
  try { heroSamples = JSON.parse((stage && stage.getAttribute('data-frl-hero-samples')) || '[]'); } catch (err) {}
  var heroIdx = 0, heroBusy = false;
  var heroImg = stage ? stage.querySelector('.frl-3d__photo img[data-frl-photo]') : null;
  var heroSource = stage ? stage.querySelector('.frl-3d__photo source[data-frl-photo]') : null;
  var heroNext = stage ? stage.querySelector('.frl-3d__next') : null;
  var narrowMq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  function heroUrl(s) {
    var hi = (window.devicePixelRatio || 1) > 1.4;
    return narrowMq && narrowMq.matches ? (hi ? s.l : s.ls) : (hi ? s.p : s.ps);
  }
  function preloadHero(i) { var s = heroSamples[i]; if (s) { var im = new Image(); im.src = heroUrl(s); } }
  function rotateHero() {
    if (heroSamples.length < 2 || !heroImg || !heroNext || file || heroBusy) return;
    var i = (heroIdx + 1) % heroSamples.length, s = heroSamples[i];
    heroBusy = true;
    heroNext.onerror = function () { heroNext.onerror = null; heroBusy = false; };
    heroNext.onload = function () {
      heroNext.onload = null;
      heroNext.classList.add('is-in');
      setTimeout(function () {
        var done = function () {
          heroNext.classList.remove('is-in');
          heroNext.removeAttribute('src');
          heroBusy = false;
          preloadHero((heroIdx + 1) % heroSamples.length);
        };
        if (file) { done(); return; }               // a visitor's photo arrived meanwhile
        heroIdx = i;
        var pset = s.ps + ' 520w, ' + s.p + ' 1000w', lset = s.ls + ' 520w, ' + s.l + ' 1000w';
        if (heroSource) { heroSource.setAttribute('srcset', lset); heroSource.setAttribute('data-frl-srcset', lset); }
        heroImg.setAttribute('srcset', pset);
        heroImg.setAttribute('data-frl-srcset', pset);
        heroImg.setAttribute('data-frl-src', s.p);
        heroImg.src = s.p;
        heroImg.alt = s.alt;
        if (heroImg.decode) heroImg.decode().then(done, done); else setTimeout(done, 80);
      }, 900);
    };
    heroNext.src = heroUrl(s);
  }

  /* ---------------- try it with your photo ---------------- */
  var photoImgs = $$('img[data-frl-photo]'), photoSources = $$('source[data-frl-photo]');
  photoImgs.concat(photoSources).forEach(function (el) {
    el.setAttribute('data-frl-src', el.getAttribute('src') || '');
    el.setAttribute('data-frl-srcset', el.getAttribute('srcset') || '');
  });
  var file = null, url = null;
  function say(msg) { var n = $('[data-frl-msg]'); if (n) { n.textContent = msg; n.hidden = !msg; } }
  function usePhoto(f) {
    if (!f) return;
    if (f.type && !/^image\//.test(f.type)) { say('That file is not a photo. Try a JPEG or PNG.'); return; }
    var u = URL.createObjectURL(f), probe = new Image();
    probe.onload = function () {
      if (url) URL.revokeObjectURL(url);
      file = f; url = u;
      var landscape = probe.naturalWidth > probe.naturalHeight * 1.03;
      // A print-shaped frame (A-series, portrait or landscape); the photo crops to fit.
      root.style.setProperty('--frl-ar', landscape ? '1414 / 1000' : '1000 / 1414');
      root.classList.toggle('is-portrait-photo', !landscape);
      photoImgs.forEach(function (img) { img.removeAttribute('srcset'); img.src = u; });
      photoSources.forEach(function (s) { s.setAttribute('srcset', u); });
      root.classList.add('has-photo');
      say('');
      userTouched();
      enter();
      track('frl_try_photo', { frl_surface: 'home', frl_orientation: landscape ? 'landscape' : 'portrait' });
    };
    probe.onerror = function () {
      URL.revokeObjectURL(u);
      say('This browser cannot preview that file (HEIC and RAW files often cannot). You can still upload it on the order page.');
    };
    probe.src = u;
  }
  function useSample() {
    if (url) URL.revokeObjectURL(url);
    file = null; url = null;
    root.style.removeProperty('--frl-ar');
    root.classList.remove('is-portrait-photo', 'has-photo');
    photoImgs.forEach(function (img) {
      img.src = img.getAttribute('data-frl-src');
      var ss = img.getAttribute('data-frl-srcset'); if (ss) img.setAttribute('srcset', ss);
    });
    photoSources.forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-frl-srcset')); });
  }
  var input = $('input[type="file"]');
  $$('[data-frl-pick]').forEach(function (b) {
    b.addEventListener('click', function () { if (input) input.click(); });
  });
  if (input) input.addEventListener('change', function () {
    var f = input.files && input.files[0];
    if (f) usePhoto(f);
    input.value = '';
  });
  $$('[data-frl-samples]').forEach(function (b) { b.addEventListener('click', useSample); });

  /* ---------------- see it in every size: carry the photo over ---------------- */
  function put(record) {
    return new Promise(function (resolve) {
      try {
        var req = indexedDB.open(DB, 1);
        req.onupgradeneeded = function () { if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE); };
        req.onerror = function () { resolve(false); };
        req.onsuccess = function () {
          try {
            var tx = req.result.transaction(STORE, 'readwrite');
            tx.objectStore(STORE).put(record, KEY);
            tx.oncomplete = function () { resolve(true); };
            tx.onerror = function () { resolve(false); };
          } catch (err) { resolve(false); }
        };
      } catch (err) { resolve(false); }
    });
  }
  /* Safari Private Browsing cannot keep a File in IndexedDB (2026-10-30): retry
     with the photo's bytes, which the landing page also reads. */
  function save(record) {
    return put(record).then(function (ok) {
      var f = record.file;
      if (ok || !f || typeof f.arrayBuffer !== 'function') return ok;
      return f.arrayBuffer().then(function (buf) {
        var copy = {};
        for (var k in record) if (k !== 'file') copy[k] = record[k];
        copy.bytes = buf;
        return put(copy);
      }, function () { return false; });
    });
  }
  $$('[data-frh-go]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      track('frl_home_click', { frl_has_photo: !!file, frl_colour: colour });
      if (!file) return;
      e.preventDefault();
      a.setAttribute('aria-busy', 'true');
      var href = a.getAttribute('href');
      var gone = false;
      var go = function () { if (gone) return; gone = true; location.href = href + (href.indexOf('?') >= 0 ? '&' : '?') + 'tried=1'; };
      setTimeout(go, 2500);
      save({ v: 1, ts: Date.now(), file: file, name: file.name || 'photo.jpg', type: file.type || 'image/jpeg', colour: colour }).then(go);
    });
  });
})();
